import React from 'react';
import {styles} from './indicator_styles.web';
import {
  createBgColorMap,
  fontMap,
  IndicatorBorderWidthySize,
  IndicatorProps,
} from './indicator_types.web';
import {useTheme} from '../../../../utils/theming/themeProvider';

const Indicator = (props: React.PropsWithChildren<IndicatorProps>) => {
  // Props
  const {id, className, size, color, type, quantity, containerStyle} = props;

  // Styles
  const {colors, fontStyles} = useTheme();
  const generalStyles = styles();
  const bgColor = createBgColorMap(colors)[color];
  const font = fontMap(fontStyles)[size];

  return (
    <div
      id={id}
      className={className}
      style={{
        ...generalStyles.indicatorContainer,
        minWidth: parseInt(size),
        height: parseInt(size),
        backgroundColor: bgColor,
        padding: quantity && quantity?.toString()?.length > 1 ? 1 : 0,
        borderRadius: parseInt(size) <= 16 ? 16 : 28,
        border: `${IndicatorBorderWidthySize[size]}px solid ${
          type === 'quantity' ? colors.neutral100 : bgColor
        }`,
        ...containerStyle,
      }}>
      {quantity && quantity >= 0 && type === 'quantity' ? (
        <p
          style={{
            ...generalStyles.indicatorText,
            ...font,
            lineHeight: font.fontSize + 'px',
            color: colors.neutral100,
          }}>
          {quantity}
        </p>
      ) : null}
    </div>
  );
};

export default Indicator;
